<template>
  <div class="mobile-app-offer">
    <div class="mobile-app-offer__container">
      <div class="text-md font-bold text-white leading-tight mr-auto">{{ $t('goToAppText') }}</div>
      <a v-if="mobileOS === 'iOS'"
         href="https://apps.apple.com/ru/app/moneykeeper-%D1%83%D1%87%D0%B5%D1%82-%D1%80%D0%B0%D1%81%D1%85%D0%BE%D0%B4%D0%BE%D0%B2/id1542338653">
        <img :src="appStoreBtnLogo" alt="App Store icon">
      </a>
      <a v-else-if="mobileOS === 'Android'"
         href="https://play.google.com/store/apps/details?id=com.apperator.moneykeeper">
        <img :src="googlePlayBtnLogo" alt="Play Market icon">
      </a>
    </div>
  </div>
</template>

<script>
import IconCross from "@/components/icons/IconCross";
import appStoreBtnLogo from '@/assets/icons/download-appstore.svg'
import googlePlayBtnLogo from '@/assets/icons/download-googleplay.svg'

export default {
  name: "MobileApplicationOffer",
  components: {IconCross},
  data() {
    return {
      appStoreBtnLogo,
      googlePlayBtnLogo,
      displayMobileAppOffer: false
    }
  },
  computed: {
    mobileOS() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return null;
    }
  },
  i18n: {
    messages: {
      en: {
        goToAppText: 'Better experience in app!'
      },
      ru: {
        goToAppText: 'Удобнее в приложении!'
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-app-offer {
  @apply px-6 py-6 -mb-6;
  background: rgba(0, 0, 0, 0.4);

  img {
    width: 110px;
  }

  &__container {
    @apply flex items-center mx-auto;
    max-width: 300px;
  }

  //@media(min-width: 768px) {
  //  display: none;
  //}
}
</style>